module.exports = __webpack_public_path__ + "img/memory_32.eb09ed9c.jpg";